import './index.css'

const DestinationItem = props => {
  const {features} = props
  const {name, imgUrl} = features
  return (
    <li className="individual-destination-cont">
      <img className="image-prop" src={imgUrl} alt={name} />
      <p>{name}</p>
    </li>
  )
}

export default DestinationItem
